import { validateNumericString } from './validateNumericString';

export function validatePremiseId(premiseId: string | number | undefined, required = true): string | undefined {
	return validateNumericString('Premise Id', premiseId, 10, 10, required);
}
